"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
exports.PRICING_PLAN_SECTION_ID = 'membership_plan_picker_tpa';
exports.RTL_LANGUAGES = ['ar', 'fa', 'he'];
//# sourceMappingURL=bookings.const.js.map